module.exports = __webpack_public_path__ + "static/media/banner-curs-dictie.3ca8ff85.jpg";